/* Volumetric Pricing Settings, Vue Component (BCR-156) */
<template>
  <v-card id="volumetric-pricing-settings">
    <v-card-title>Volumetric Pricing</v-card-title>

    <v-card-text>
      <p class="mb-6">
        These settings drive volumetric shipping pricing for both <strong>quotes</strong> and <strong>bespoke orders</strong>.
        Shipping = (price per volume &times; volume in cm&sup3;), then + fuel surcharge %, then + base, then + margin %,
        rounded up to the nearest 1p. Heavy/large and other option surcharges are added on top.
        <br /><br />
        <strong>Note:</strong> The base price is ignored (treated as &pound;0) when the Heavy / two-person surcharge
        is being applied, so the heavy charge replaces the base rather than stacking on top of it.
      </p>

      <v-form ref="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="request.PricePerVolume"
              label="Price per volume"
              prefix="£"
              suffix="per cm³"
              type="number"
              outlined dense
              hint="Shared by quotes and bespoke orders"
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="request.FuelSurchargePercent"
              label="Fuel surcharge"
              suffix="%"
              type="number"
              outlined dense
              hint="Shared by quotes and bespoke orders"
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="request.MarginPercent"
              label="Margin"
              suffix="%"
              type="number"
              outlined dense
              hint="Shared by quotes and bespoke orders"
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="request.BespokePriceBase"
              label="Base price"
              prefix="£"
              type="number"
              outlined dense
              hint="Shared by quotes and bespoke orders"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-text>
      <v-btn color="primary" @click="Update" :loading="loading">
        <v-icon size="18" class="me-1">{{ icons.mdiContentSaveOutline }}</v-icon>
        <span>Update</span>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import store from '@/store'
import { mdiContentSaveOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  setup() {

    const request = ref({
      PricePerVolume: 0,
      FuelSurchargePercent: 0,
      MarginPercent: 0,
      BespokePriceBase: 0
    });
    const loading = ref(false);
    const form = ref(null);

    const fetchData = () => {
      store.dispatch('app/fetchVolumetricSettings')
        .then(response => {
          if (response && response.data) request.value = response.data;
        })
        .catch(error => console.log(error));
    };
    fetchData();

    const Update = () => {
      loading.value = true;
      store.dispatch('app/updateVolumetricSettings', request.value)
        .then(() => { loading.value = false; })
        .catch(error => { loading.value = false; console.log(error); });
    };

    return {
      request,
      loading,
      form,
      Update,
      icons: { mdiContentSaveOutline }
    };
  }
}
</script>

<style lang="scss" scoped></style>
